<section class="dz-card" [class.dz-card--recolhido]="!aberto()">
  <div class="dz-card__head">
    <h2 class="dz-card__title">
      <button
        type="button"
        class="dz-card__toggle"
        [attr.aria-expanded]="aberto()"
        aria-controls="registro-cadastro-corpo"
        [title]="aberto() ? 'Recolher' : 'Expandir'"
        (click)="aberto.set(!aberto())">
        <span class="dz-card__icon" aria-hidden="true">🏢</span>
        Cadastro (Receita Federal)
        <i class="pi pi-chevron-down dz-card__chevron" aria-hidden="true"></i>
      </button>
    </h2>
    <!-- No Dossiê estes chips moram no cabeçalho da empresa; na tela do deal esse cabeçalho é o
         hero (que já mostra razão social e CNPJ), então eles vêm para cá. -->
    <div class="dz-card__actions">
      @if (empresa().porte) {
        <span class="dz-chip">{{ empresa().porte }}</span>
      }
      @if (empresa().situacaoCadastral) {
        <span class="dz-chip" [class.dz-chip--green]="ativa()" [class.dz-chip--red]="!ativa()">
          {{ empresa().situacaoCadastral }}
        </span>
      }
      @if (empresa().simples?.optante) {
        <span class="dz-chip dz-chip--cyan">Simples Nacional</span>
      }
      @if (empresa().simples?.mei) {
        <span class="dz-chip dz-chip--cyan">MEI</span>
      }
      @if (empresa().matrizFilial) {
        <span class="dz-chip">{{ empresa().matrizFilial }}</span>
      }
    </div>
  </div>

  <div class="dz-card__body" id="registro-cadastro-corpo" [hidden]="!aberto()">
    @if (!ativa() && empresa().situacaoCadastral) {
      <p class="dz-note dz-note--alert situacao">
        Situação cadastral: {{ empresa().situacaoCadastral }}
        @if (motivo()) {
          — {{ motivo() }}
        }
        .
      </p>
    }

    <dl class="fields">
      @for (c of campos(); track c.rotulo) {
        <div class="fields__item">
          <dt class="dz-label">{{ c.rotulo }}</dt>
          <dd class="fields__value">{{ c.valor ?? '—' }}</dd>
        </div>
      }
    </dl>

    @if (cnaesSecundarios().length) {
      <div class="secondary">
        <span class="dz-label">CNAEs secundários ({{ cnaesSecundarios().length }})</span>
        <div class="secondary__list">
          @for (c of cnaesSecundarios(); track $index) {
            <span class="dz-chip">{{ c }}</span>
          }
        </div>
      </div>
    }
  </div>
</section>
